import type { Traversal } from '@ark/schema';

const swiftRegex = /^[a-zA-Z0-9/\-?:().,'+ ]*$/;

export const checkStringValidSwiftCharacters = (
  value: string,
  ctx?: Traversal,
): value is string => {
  if (!swiftRegex.test(value)) {
    return (
      ctx?.reject({
        message: 'VALIDATION_INVALID_SWIFT_CHARACTERS',
      }) ?? false
    );
  }
  return true;
};
